import {
  GetTemplateMaster,
  PutTemplateMaster,
  PostTemplateMaster,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export type TemplateMasterParams = {
  templateId: number;
};

const endPoint = 'template';

export const getTemplateMaster = async (
  params?: TemplateMasterParams,
): Promise<GetTemplateMaster> => {
  const queryParams = new URLSearchParams();

  if (params) {
    queryParams.append('templateId', params.templateId.toString());
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const putTemplateMaster = async (
  newTemplateMaster: PutTemplateMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newTemplateMaster),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const postTemplateMaster = async (
  newTemplateMaster: PostTemplateMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(newTemplateMaster),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteTemplateMaster = async (
  params: TemplateMasterParams,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('templateId', params.templateId.toString());
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
